import Actions from './Actions.styled';

export default Actions;
